<template>
  <div class="work-summary col-12">
    <div class="card card-default mb-4">
      <accordian-display
        :title="title"
        icon="fas fa-book fa-fw"
        :headerClass="'card-header rounded-1'">
        <div class="card-body">
          <div class="row">
            <div class="col-md-7">
              <responsive-table
                :collapse="false"
                :hideColumns="true">
                <template slot="rows">
                  <tr>
                    <td colspan="5">
                      <h4>Completed-Sent Reports</h4>
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Reference</strong></td>
                    <td><strong>Time Stamp (sent)</strong></td>
                    <td><strong>Report Cost</strong></td>
                    <td><strong>Rate</strong></td>
                    <td><strong>Amount Due</strong></td>
                  </tr>
                  <tr v-for="(sentReport, index) in summary.bill.sentReports" :key='index'>
                    <td>
                      <router-link :to="{ path: '/approvedQuotes?report=' + sentReport.QuoteUuid }" >
                        {{ sentReport.Quote.reference }}
                      </router-link>
                    </td>
                    <td>{{ sentReport.createdAt | date_time_format }}</td>
                    <td>{{ sentReport.Quote.actualCost | toDollarAmount }}</td>
                    <td>{{ sentReport.contractorRate }}% </td>
                    <td>{{ sentReport.amountDue | toDollarAmount }}</td>
                  </tr>
                  <tr>
                    <td colspan="4"><strong>Total</strong></td>
                    <td><strong>{{ summary.bill.totalAmount | toDollarAmount }}</strong></td>
                  </tr>
                </template>
              </responsive-table>
            </div>
            <div class="col-md-5">
              <responsive-table
                :collapse="false"
                :hideColumns="true">
                <template slot="rows">
                  <tr>
                    <td colspan="2">
                      <h4>Completed-Not-Sent Reports</h4>
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Reference</strong></td>
                    <td><strong>Time Stamp (completed)</strong></td>
                  </tr>
                  <tr v-for="(completedReport, index) in summary.completedReports" :key='index'>
                    <td>
                      <router-link :to="{ path: '/approvedQuotes?report=' + completedReport.uuid }" >
                        {{ completedReport.reference }}
                      </router-link>
                    </td>
                    <td>{{ completedReport.reportCompletedDate | date_time_format }}</td>
                  </tr>
                </template>
              </responsive-table>
            </div>
          </div>
        </div>
      </accordian-display>
    </div>
  </div>
</template>


<script>
  import AccordianDisplay from '@/components/displays/AccordianDisplay'
  import ResponsiveTable from '@/components/ui/ResponsiveTable'
  import moment from 'moment-timezone'
  export default {
    name: 'WorkSummaryCard',
    props: {
      object: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    components: {
      AccordianDisplay,
      ResponsiveTable
    },
    computed: {
      summary () {
        return {
          ...this.object
        }
      },
      title () {
        let start = moment(this.summary.month.start).tz('Australia/Melbourne').format('DD/MM/YYYY')
        let end = moment(this.summary.month.end).tz('Australia/Melbourne').format('DD/MM/YYYY')
        let word = '$' + this.summary.bill.totalAmount + ' due for the month ' + start + ' - ' + end
        return word
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/cards/WorkSummary.vue